<template>
  <div class="star-rating flex items-center" :class="$attrs.class">
    <span class="mr-1 text-xs text-blakc dark:text-white"
      >({{ props.value.toFixed(1) }})</span
    >
    <span v-for="i in 5" :key="i" class="relative inline-block w-4 h-4">
      <!-- Empty star (background) -->
      <svg
        class="absolute top-0 left-0 w-full h-full text-gray-400 dark:text-white"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <polygon
          points="10,1 12.59,7.36 19.51,7.36 13.97,11.63 16.56,17.99 10,13.72 3.44,17.99 6.03,11.63 0.49,7.36 7.41,7.36"
        />
      </svg>
      <!-- Filled star (foreground, clipped) -->
      <svg
        class="absolute top-0 left-0 w-full h-full text-(--main-color)"
        fill="currentColor"
        viewBox="0 0 20 20"
        :style="{
          position: 'absolute',
          top: 0,
          left: 0,
          clipPath: `inset(0 ${100 - getFill(i)}% 0 0)`,
        }"
      >
        <polygon
          points="10,1 12.59,7.36 19.51,7.36 13.97,11.63 16.56,17.99 10,13.72 3.44,17.99 6.03,11.63 0.49,7.36 7.41,7.36"
        />
      </svg>
    </span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ value: number }>();

function getFill(star: number) {
  // star: 1-based index
  if (props.value >= star) return 100;
  if (props.value + 1 > star) return (props.value - (star - 1)) * 100;
  return 0;
}
</script>

<style scoped>
.small-stars .star-rating span {
  width: 1rem !important;
  height: 1rem !important;
}
.small-stars .star-rating svg {
  width: 1rem !important;
  height: 1rem !important;
}
.small-stars .star-rating .ml-2 {
  margin-left: 0.25rem !important;
  font-size: 0.75rem !important;
}
</style>
